module.exports = __webpack_public_path__ + "media/theme/sample__itunes--sp-e5450486.png";